import { isEmpty } from "lodash";
import { useFormContext } from "react-hook-form";
import React, { ReactNode } from "react";

import { Button, IButtonProps } from "../Button";
import { ChakraText } from "../ChakraText";
import { CustomColorScheme } from "../Button/types/CustomColorScheme";

interface IProps extends IButtonProps {
  btnTitle?: ReactNode;
}

const SpinnerButton = ({
  btnTitle = <ChakraText>Potwierdź</ChakraText>,
  ...props
}: IProps) => {
  const {
    formState: { isSubmitting },
    errors,
  } = useFormContext();
  const hasErrors = !isEmpty(errors);
  return (
    <Button
      customColorScheme={CustomColorScheme.Green}
      isLoading={isSubmitting}
      disabled={isSubmitting || hasErrors}
      type="submit"
      {...props}
    >
      {btnTitle}
    </Button>
  );
};

export { SpinnerButton };
